import { render, staticRenderFns } from "./material-trace-history.vue?vue&type=template&id=8dd6c8ce&"
import script from "./material-trace-history.vue?vue&type=script&lang=js&"
export * from "./material-trace-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports